import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function bulkUploadLeadApi(data) {
    return ApiRequest.fetchAdmin({
      method: "post",
      url: API_END_POINTS.BULK_UPLOAD_LEAD,
      data,
    }).then((response) => response.data);
  }